import * as types from '../actions/actionTypes';

const reducer = (state = {}, action) => {
  switch (action.type) {
    case types.SORT_BY: {
      const { field, order } = action.payload;

      return {
        ...state,
        [field]: order,
      };
    }
    default:
      return state;
  }
};

export default reducer;
